module.exports = __webpack_public_path__ + "img/img_txt_phone_jalnan.211fe5da.svg";